
/**
 * Apply conditional logic to a field to determine if it should display or not
 *  NOTE: must remain functionally identical to the backend wb_pdfs::conditional_visible()
 *  AND: Features/FieldSet.jsx
 *  AND: pages/form/index.js
 *  AND pages/application.js
 *
 * @param conds [object] Conditions object, including Action, Multiple, Criteria keys
 *
 * @return bool Whether field is visible (true) or hidden (false)
 */
const applyConditionalLogic = ( conds, originalValues, fields, currentValues ) => {
    
    const conditionState = conds.action ?? 'HIDE';
    const conditionCompare = conds.multiple ?? 'AND';
    const conditions = conds.criteria ?? [];
    
    let isVisible = true;
    if( 'SHOW' == conditionState ){
        isVisible = false;
    }
    
    let tmpIsDD = false;
    
    let matched = false;
    let matchAndFail = false;
    conditions.forEach((condition) => {
        const fieldId = condition.field;
        const reqValue = condition.value;
        const compare = condition.compare ?? '=';
        
        if( 'payment_type' == fieldId && 'dd' == reqValue ){
            tmpIsDD = true;
        }
        
        // Get field value (server first, then state)
        let fldValue = null;
        if( null != originalValues ){
            fldValue = originalValues['meta_'+fieldId] ?? fldValue; // From Server
        }
        if( null != currentValues ){
            fldValue = currentValues[fieldId] ?? fldValue; // From State
        }
        if( null == fldValue ){
            let fldDefault = '';
            for( const fldArea in fields ){
                const fldArray = fields[fldArea];
                fldArray.forEach( (thFld) => {
                    if( fieldId === thFld.id ){
                        fldDefault = thFld.default ?? '';
                    }
                });
            }
            
            fldValue = fldDefault;
        }
        
        if(
            ('='==compare && reqValue == fldValue) ||
            ('CONTAINS'==compare && fldValue.includes(reqValue))
        ){
            if( 'AND' !== conditionCompare || !matchAndFail ){
                matched = true;
            }
        } else if( 'AND' == conditionCompare ){
            matched = false;
            matchAndFail = true;
        }
    });
    
    if( matched ){
        if( 'SHOW' == conditionState ){
            isVisible = true;
        } else {
            isVisible = false;
        }
    }
    
    if(tmpIsDD){
        console.log( 'Conditions: ', conds, conditionCompare, isVisible );
    }
    
    return isVisible;
};
 
export default applyConditionalLogic;
